import React from "react";
import {
  Popper,
  Paper as MuiPaper,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Person as PersonIcon } from "@mui/icons-material";
import {
  BLUE,
  BLUE_LIGHT,
  BLUE_MED,
  BLUE_PALE,
  BORDER,
  INK,
  INK_MUTED,
} from "./shared";

// ─── Suggestion Popper ───────────────────────────────────────────────────────
const SuggestionPopper = ({ open, anchorEl, customers, onSelect, loading }) => {
  // A missing or detached anchor gives Popper a zero-sized rect, which drops
  // the dropdown into the top-left corner of the viewport. Render nothing
  // rather than showing a floating, disconnected list.
  const anchored = !!anchorEl && anchorEl.isConnected !== false;
  if (!anchored) return null;

  return (
  <Popper
    open={open && (customers?.length || 0) > 0}
    anchorEl={anchorEl}
    placement="bottom-start"
    style={{ width: anchorEl.offsetWidth || "auto", zIndex: 1300 }}
    modifiers={[
      { name: "flip", enabled: true },
      {
        name: "preventOverflow",
        options: { boundary: "viewport", padding: 8 },
      },
    ]}
  >
    <MuiPaper
      sx={{
        maxHeight: { xs: "45vh", sm: 300 },
        overflow: "auto",
        mt: 0.5,
        boxShadow: "0 8px 32px rgba(15,23,42,0.15)",
        borderRadius: "10px",
        border: `1px solid ${BORDER}`,
      }}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
          <CircularProgress size={20} sx={{ color: BLUE }} />
        </Box>
      ) : (
        <List dense>
          {customers?.map((cust) => (
            <ListItem
              key={cust.customer_id}
              button
              onClick={() => onSelect(cust)}
              sx={{
                "&:hover": { backgroundColor: BLUE_PALE },
                borderBottom: `1px solid ${BORDER}`,
                "&:last-child": { borderBottom: "none" },
              }}
            >
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: BLUE_LIGHT,
                    width: 32,
                    height: 32,
                    border: `1px solid ${BLUE_MED}44`,
                  }}
                >
                  <PersonIcon fontSize="small" sx={{ color: BLUE }} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{ color: INK }}
                  >
                    {cust.name}
                  </Typography>
                }
                secondary={
                  <>
                    <Typography
                      variant="caption"
                      display="block"
                      sx={{ color: INK_MUTED }}
                    >
                      📱 {cust.mobile}
                    </Typography>
                    {cust.relative_name && (
                      <Typography
                        variant="caption"
                        display="block"
                        sx={{ color: INK_MUTED }}
                      >
                        👤{" "}
                        {cust.relative_relation
                          ? `${cust.relative_relation} `
                          : ""}
                        {cust.relative_name}
                      </Typography>
                    )}
                    {cust.aadhar && (
                      <Typography
                        variant="caption"
                        display="block"
                        sx={{ color: INK_MUTED }}
                      >
                        🪪 {cust.aadhar}
                      </Typography>
                    )}
                    {cust.pan && (
                      <Typography
                        variant="caption"
                        display="block"
                        sx={{ color: INK_MUTED }}
                      >
                        🆔 {cust.pan}
                      </Typography>
                    )}
                  </>
                }
              />
            </ListItem>
          ))}
        </List>
      )}
    </MuiPaper>
  </Popper>
  );
};

export default SuggestionPopper;
